import {
  Avatar,
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  LinearProgress,
  MenuItem,
  Pagination,
  Popover,
  Select,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { SELECT_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from '../../constants/colors';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { useJiffyStaffControllers } from './controller';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import FormJiffyStaffView from './form';
import { numberFormat } from '../../utils/nunberFormat';
import { FETCH_MORE_DATA_AMOUNT } from '../../config-global';
import StatusChip from '../../components/StatusChip';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmDialog from '../../components/ConfirmDialog';
import TabPanelActiveComponent from './components/tabPanel';
import TableSearchNotFound from '../../components/tableSearchNotFound';
import { IMAGE_URL_MERCHANT_USER } from '../../lib/endpoints/merchantUser';
import { useTranslation } from 'react-i18next';
import { EN_ACCEPT_LANGUAGE } from '../../constants/acceptLanguageApi';
import { MerchantUserEnum } from '../../enums/merchantUser';
import { ConvertMerchantUserTypeToString } from '../../utils/convertMerchantTypeToString';
import TabPanelMerchantRole from './components/tabUserType';
import LoadingAnimatedIcon from '../../components/loading/loadingAnimated';
import LoadingAnimatedIconTable from '../../components/loading/loadingTable';
import SelectedBranchComponentVoid from '../../components/SelectedBranchVoid';

const JiffyStaffView = () => {
  const { t, i18n } = useTranslation("global");
  const controller = useJiffyStaffControllers();

  return (
    <>
      {controller.openForm ? (
        <FormJiffyStaffView
          onClose={controller.handleCloseForm}
          selectedData={controller.selectedData}
          onFetchData={controller.handleFetchData}
          setSelected={controller.setSelectedData}
          branchValue={controller.branchValue}
          merchantType={controller.tabMerchantType}
        />
      ) : (
        <>
          {
            controller.loadingMainData ?
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingAnimatedIcon />
              </Box> : <Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>
                    {t("merchantUser_page.Merchant User")}
                  </Typography>
                  <Box sx={{ ml: 2 }}>
                    <TextField
                      placeholder={`${t("merchantUser_page.Search by fullName")}`}
                      sx={{ maxWidth: 250 }}
                      fullWidth
                      value={controller.searchValue}
                      onChange={controller.handleSearch}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      size="small"
                    />
                  </Box>
                  <Box sx={{ ml: 2, width: 200 }}>
                    {/* <FormControl fullWidth sx={{ maxWidth: 250 }} size="small">
                      <InputLabel id="merchant-label-id" shrink={true}>{t("Branch")}</InputLabel>
                      <Select
                        labelId="merchant-label-id"
                        id="merchant-id"
                        value={controller.branchValue}
                        label="Merchant"
                        onChange={controller.handleSelectedBranch}
                        sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                      >
                        {
                          controller.branchData?.map((item: any) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.nameEn : item?.nameLa}</MenuItem>)
                        }
                      </Select>
                    </FormControl> */}
                    <SelectedBranchComponentVoid value={controller.branchValue} onSelectMerchant={controller.handleSelectedBranch} merchantData={controller.branchData} />

                  </Box>
                </Box>
                {/* show status bar */}
                <Box sx={{ mt: 2, display: 'flex' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box sx={{
                        backgroundColor: '#C4EAFF', borderRadius: '16px', p: 4, boxShadow:
                          '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                      }}>
                        <Box>
                          <Typography variant='h6' color={TEXT_TITLE_COLOR} fontWeight="bold" sx={{ mb: 1 }}>{controller.tabMerchantType === MerchantUserEnum.MERCHANT ? t("merchantUser_page.Merchant Manager") : t("merchantUser_page.Merchant")}</Typography>
                          <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} fontSize={32}> {controller.filterByRoleMerchant.length}</Typography>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box sx={{
                        backgroundColor: '#C8FACD', borderRadius: '16px', p: 4, boxShadow:
                          '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                      }}>
                        <Box>
                          <Typography variant='h6' color={TEXT_TITLE_COLOR} fontWeight="bold" sx={{ mb: 1 }}>{controller.tabMerchantType === MerchantUserEnum.MERCHANT ? t("merchantUser_page.Active Manager") : t("merchantUser_page.Active Staff")}</Typography>
                          <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} fontSize={32}>{controller.numberOfActiveUsers}</Typography>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box sx={{
                        backgroundColor: '#FFACB6', borderRadius: '16px', p: 4, boxShadow:
                          '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                      }}>
                        <Box>
                          <Typography variant='h6' color={TEXT_TITLE_COLOR} fontWeight="bold" sx={{ mb: 1 }}>{controller.tabMerchantType === MerchantUserEnum.MERCHANT ? t("merchantUser_page.InActive Manager") : t("merchantUser_page.InActive Staff")}</Typography>
                          <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} fontSize={32}>{controller.numberOfInActiveUsers}</Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                {/* status bar */}
                <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2, mb: 2 }}>
                  <Button
                    color='secondary'
                    variant="contained"
                    sx={{ textTransform: 'none', borderRadius: '8px', color: '#fff', width: 180 }}
                    onClick={controller.handleOpenForm}
                  >
                    <AddIcon />
                    &nbsp; {t("merchantUser_page.Create User")}
                  </Button>
                </Box>
                {
                  controller.loadingData ?
                    <>
                      {/* <Skeleton variant="rounded" animation="wave" width='auto' height={40} />
                      <Skeleton variant="rounded" animation="wave" width='auto' height={40} sx={{ mt: 1 }} />
                      <Skeleton variant="rounded" animation="wave" width='auto' height={200} sx={{ mt: 1 }} /> */}
                      <LinearProgress />
                    </> :
                    <>
                      <Box>
                        <TabPanelMerchantRole value={controller.tabMerchantType} onChange={controller.handleSelectMerchantRole} />
                        <TabPanelActiveComponent value={controller.tabValue} onChange={controller.handleSetTabStatus} />
                      </Box>
                      <Box sx={{ mt: 1 }}>
                        <TableContainer>
                          <Table>
                            <TableHead sx={{ background: '#F4F6F8' }}>
                              <TableRow>
                                <TableCell sx={{ borderBottom: 'none' }}>{t("merchantUser_page.No")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{t("merchantUser_page.Profile")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{t("merchantUser_page.Fullname")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }} align='left'>{t("merchantUser_page.Username")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{t("merchantUser_page.Phone number")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{t("merchantUser_page.Role")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }} align='center'>{t("merchantUser_page.Status")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {
                                controller.rows?.map((row: any, index: number) => {
                                  const { id, profile, username } = row;
                                  const isActive: boolean = !row?.isBan;
                                  return (
                                    <TableRow key={index}>
                                      <TableCell sx={{ borderBottom: 'none' }}>
                                        {numberFormat(index + 1 + 10 * (controller.currentPage - 1))}
                                      </TableCell>
                                      <TableCell sx={{ borderBottom: 'none' }}>
                                        <Avatar src={IMAGE_URL_MERCHANT_USER + profile?.image?.url} />
                                      </TableCell>
                                      <TableCell sx={{ borderBottom: 'none' }}>
                                        {profile?.firstname} {profile?.lastname}
                                      </TableCell>
                                      <TableCell sx={{ borderBottom: 'none' }} align='left'>
                                        {username}
                                      </TableCell>
                                      <TableCell sx={{ borderBottom: 'none' }}>
                                        {profile?.tel}
                                      </TableCell>
                                      <TableCell sx={{ borderBottom: 'none' }}>
                                        {t("merchantUser_page." + row?.role_type)}
                                      </TableCell>
                                      <TableCell sx={{ borderBottom: 'none' }} align='center'>
                                        <StatusChip status={isActive} />
                                      </TableCell>
                                      <TableCell sx={{ borderBottom: 'none' }} align="right">
                                        <IconButton size="large" color="inherit" onClick={(e: any) => controller.handleOpenMenu(e, id, profile?.id)}>
                                          <MoreHorizIcon />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  )
                                })
                              }
                            </TableBody>
                            {
                              controller.isSearchNotFound && (
                                <TableSearchNotFound
                                  searchValue={controller.searchValue}
                                  colSpan={9}
                                />
                              )
                            }
                          </Table>
                        </TableContainer>
                        <Divider sx={{ mt: 1, mb: 1 }} />
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                          <Pagination color="primary" count={controller.countPagination} page={controller.currentPage} onChange={controller.handleChangePage} />
                        </Box>
                      </Box>
                      <Popover
                        open={Boolean(controller.openMenu)}
                        anchorEl={controller.openMenu}
                        onClose={controller.onCloseMenu}
                        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        PaperProps={{
                          sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                              px: 1,
                              typography: 'body2',
                              borderRadius: 0.75,
                            },
                          },
                        }}
                      >
                        <MenuItem onClick={() => controller.handleOpenEditForm()}> <EditIcon /> &nbsp;&nbsp; {t("Edit")}</MenuItem>
                        <MenuItem sx={{ color: 'error.main' }} onClick={() => controller.handleOpenDeleteForm()}> <DeleteIcon /> &nbsp;&nbsp; {t("Delete")}</MenuItem>
                      </Popover>
                      <ConfirmDialog
                        open={controller.openDelete}
                        title={t('Do you want to delete this Data ?')}
                        loading={controller.loadingDeleteButton}
                        onCancel={controller.handleCloseDeleteForm}
                        onConfirm={() => controller.handleDeleteUser()}
                      />
                    </>
                }

              </Box>
          }
        </>
      )}
    </>
  );
};
export default JiffyStaffView;
